import type { ComponentPropsWithoutRef } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '../../lib/utils'

/** Native selection behavior with the shared tall form-field treatment. */
export default function Select({ children, className, ...props }: ComponentPropsWithoutRef<'select'>) {
  return (
    <div className="relative">
      <select
        {...props}
        className={cn(
          'h-12 w-full appearance-none rounded-xl border border-input-border bg-input-bg pl-4 pr-10 text-base text-foreground',
          'cursor-pointer transition-colors hover:border-input-border-hover hover:bg-surface-3',
          'focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
    </div>
  )
}
